// extracted by mini-css-extract-plugin
export var dividerLine = "_8j-3";
export var itemImage = "_8j-9";
export var lightDivider = "_8j-4";
export var modalContent = "_8j-5";
export var modalContentCompact = "_8j-6";
export var productCard = "_8j-a";
export var productImage = "_8j-b";
export var productImageCompact = "_8j-7";
export var productImagePlaceholder = "_8j-c";
export var productImagePlaceholderCompact = "_8j-8";
export var progressBarBackground = "_8j-1";
export var progressBarContainer = "_8j-0";
export var progressBarFill = "_8j-2";